import styled from 'styled-components';

export const StyledMenuTitle = styled('div')`
  margin: ${(p) => p.theme.spacing(2, 2, 1, 2)};
  opacity: 0.6;
  display: block;
  line-height: 20px;
`;
